import RGPD from "./Components/RGPD/RGPD";
const $ = require('jquery');
window.jQuery = $;
window.$ = $;

window.Switchery = require('../../../backoffice/js/libs/switchery/switchery');

require('popper.js');
window.bootstrap = require('../../vendor/bootstrap-5.1.3/dist/js/bootstrap');

require('jquery-ui');

const Kernel = require('../../../common/js/Kernel');
window.Kernel = new Kernel();

window.toastr = require('toastr');

require('../../../vendor/hegyd/core/js/hegyd-core.js');

require('../../../common/js/main');
require('./tools/scroll');

// date picker
require('bootstrap-datepicker');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.fr');

// Common
window.Kernel.registerComponent('ImagePhotoswipe', require('./Components/Common/ImagePhotoswipe').default);

window.Kernel.registerComponent('Bannier', require('./Components/Layout/Bannier').default);
window.Kernel.registerComponent('Header', require('./Components/Layout/Header').default);
window.Kernel.registerComponent('BrisachSlider', require('./Components/EspaceBrisach/BrisachSlider').default);
window.Kernel.registerComponent('Newsletter', require('./Components/Newsletter/Newsletter').default);
window.Kernel.registerComponent('ModalLauncher', require('./Components/Other/ModalLauncher').default);

//Products
window.Kernel.registerComponent('Comparator', require('./Components/Comparator/Comparator').default);
window.Kernel.registerComponent('PageComparator', require('./Components/Comparator/PageComparator').default);
window.Kernel.registerComponent('ProductFilter', require('./Components/Product/ProductFilter').default);
window.Kernel.registerComponent('Favorite', require('./Components/Product/Favorite').default);
window.Kernel.registerComponent('AddComparator', require('./Components/Product/AddComparator').default);
window.Kernel.registerComponent('AddCartFromItem', require('./Components/Product/AddCartFromItem').default);
window.Kernel.registerComponent('ProductsList', require('./Components/Product/ProductsList').default);

//Ecommerce
window.Kernel.registerComponent('AddProductToCart', require('./Components/Ecommerce/AddProductToCart').default);
window.Kernel.registerComponent('CartLine', require('./Components/Ecommerce/CartLine').default);
window.Kernel.registerComponent('CartSidebar', require('./Components/Ecommerce/CartSidebar').default);
window.Kernel.registerComponent('TruncateCart', require('./Components/Ecommerce/TruncateCart').default);
window.Kernel.registerComponent('CartQuantity', require('./Components/Ecommerce/CartQuantity').default);
window.Kernel.registerComponent('SelfDecouverte', require('./Components/Ecommerce/SelfDecouverte').default);
window.Kernel.registerComponent('Cart', require('./Components/Ecommerce/Cart').default);
window.Kernel.registerComponent('Contact', require('./Components/Ecommerce/Contact').default);
window.Kernel.registerComponent('SelectShopDelivery', require('./Components/Ecommerce/SelectShopDelivery').default);
window.Kernel.registerComponent('SelectDefaultShop', require('./Components/Ecommerce/SelectDefaultShop').default);
window.Kernel.registerComponent('SearchDefaultShop', require('./Components/Ecommerce/SearchDefaultShop').default);

//Store locatore
window.Kernel.registerComponent('StoreLocatore', require('./Components/Store/StoreLocatore').default);
window.Kernel.registerComponent('StoreDetail', require('./Components/Store/StoreDetail').default);

//News
window.Kernel.registerComponent('NewsSlider', require('./Components/News/NewsSlider').default);

//Emailing
window.Kernel.registerComponent('AppointmentForm', require('./Components/Emailing/AppointmentForm').default);
window.Kernel.registerComponent('RequestPaiement', require('./Components/Emailing/RequestPaiement').default);

//Customer Panel (Espace client FRONT)
window.Kernel.registerComponent('CustomerInfo', require('./Components/CustomerPanel/CustomerInfo').default);
window.Kernel.registerComponent('Authentification', require('./Components/CustomerPanel/Authentification').default);
window.Kernel.registerComponent('NewCustomer', require('./Components/CustomerPanel/NewCustomer').default);
window.Kernel.registerComponent('AppointmentAccordion', require('./Components/CustomerPanel/AppointmentAccordion').default);

//Authentification
window.Kernel.registerComponent('LoginFront', require('./Components/Common/LoginFront').default);

new RGPD();

window.addEventListener("DOMContentLoaded",() => {
    window.Kernel.mountComponents($('html'));
});

// Init du date picker
$('.datepicker').datepicker({
    language: "fr",
});
